import { render } from "./Settings.vue?vue&type=template&id=770d2f8f&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=770d2f8f&lang=scss"
import "./Settings.vue?vue&type=style&index=1&id=770d2f8f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770d2f8f"]])

export default __exports__